import React, {useEffect, useState} from 'react';
import {getWorthyRequest} from 'util/adminApi';
import AdminFreeFetchInput from 'components/admin/AdminFreeFetchInput';
import AdminCharityForm from 'components/admin/AdminCharityForm';

const COMPONENTS = {
    fetch: {label: 'Free Fetch', component: <AdminFreeFetchInput/>},
    charity: {label: 'Charity Form', component: <AdminCharityForm/>},
};

const AdminConsole = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [activeTab, setActiveTab] = useState('fetch');

    useEffect(() => {
        getWorthyRequest().then((res) => {
            if (res.message === 'YES') setIsAdmin(true);
        });
    }, []);

    if (!isAdmin) return <div><h1>Loading</h1><p>Please wait...</p></div>;

    return (
        <div>
            <h1>Admin Console</h1>

            <div style={{marginBottom: '1rem'}}>
                {Object.keys(COMPONENTS).map((key) => (
                    <button key={key} onClick={() => setActiveTab(key)} style={{marginRight: '0.5rem'}}>
                        {COMPONENTS[key].label}
                    </button>
                ))}
            </div>

            {COMPONENTS[activeTab].component}
        </div>
    );
};

export default AdminConsole;
